/**
 * R77 · Delivery ⇄ Financial pill toggle for Packages.
 * Hidden entirely if the caller lacks finance perms (delivery-only lock).
 */
import { Truck, Wallet } from "lucide-react";

export default function PackageModeToggle({ mode, setMode, canToggle, testid = "pkg-mode-toggle" }) {
  if (!canToggle) return null;
  return (
    <div
      className="inline-flex border border-border bg-muted/30 rounded-none overflow-hidden text-[10px] uppercase tracking-widest font-semibold"
      data-testid={testid}
      role="tablist"
      aria-label="Package view mode"
    >
      <button
        type="button"
        onClick={() => setMode("delivery")}
        className={`px-3 py-1.5 inline-flex items-center gap-1.5 transition ${
          mode === "delivery"
            ? "bg-primary text-primary-foreground"
            : "text-muted-foreground hover:bg-muted"
        }`}
        data-testid={`${testid}-delivery`}
        role="tab"
        aria-selected={mode === "delivery"}
      >
        <Truck className="w-3.5 h-3.5" />
        Delivery
      </button>
      <button
        type="button"
        onClick={() => setMode("financial")}
        className={`px-3 py-1.5 inline-flex items-center gap-1.5 transition ${
          mode === "financial"
            ? "bg-primary text-primary-foreground"
            : "text-muted-foreground hover:bg-muted"
        }`}
        data-testid={`${testid}-financial`}
        role="tab"
        aria-selected={mode === "financial"}
      >
        <Wallet className="w-3.5 h-3.5" />
        Financial
      </button>
    </div>
  );
}
